import { ButtonLoading } from "./button-loading.model";

export class FormTaxResponse {
	accessories: number;
	accumulatedTaxIncome: number;
	accumulatedTaxLoss: number;
	affectedBy: any;
	closingJournalItem: number;
	companyCode: string;
	companyId: number;
	companyName: string;
	companyNit: string;
	costNExpenses: number;
	creationDate: number;
	currentUserId: any;
	declarationDate: number;
	description: string;
	estimatedTaxableIncome: number;
	exemptions: number;
	exemptionsDocsQuantity: any;
	expirationDate: any;
	fileName: any;
	fileSaveName: any;
	fiscalCreditLastMonth: number;
	fiscalCreditNextMonth: number;
	formAccess: any;
	formCode: string;
	formMail: any;
	formName: string;
	formNumber: any;
	goodsPurchases: number;
	goodsSales: number;
	grossRent: number;
	group: number;
	id: number;
	inbox: any;
	lastModifiedDate: number;
	miContaGT: boolean;
	monthEnd: number;
	monthStart: number;
	nonDeductibleExpense: number;
	paymentJournalItem: any;
	purchasesDocsQuantity: number;
	salesDocsQuantity: number;
	servicesPurchases: number;
	servicesSales: number;
	smallPurchases: number;
	smallSales: number;
	status: number;
	taxDeterminedThisQuarter: number;
	taxRegime: number;
	taxesContributions: number;
	taxesToPay: number;
	totalToPay: number;
	totalToPayPast: number;
	type: number;
	userId: number;
	withholdings: number;
	withholdingsDocsQuantity: any;
	withholdingsLastMonth: number;
	withholdingsNextMonth: number;
	expirationDateAux!: string;
	year: number;
	history!: HistoryTaxResponse[];
	working!: boolean;
	paying!: any;
	downloading!: any;
}

export class HistoryTaxResponse {
	creationDate: number;
	description: string;
	fileName: any;
	fileSaveName: any;
	formData: any;
	formId: number;
	fromState: any;
	id: number;
	internalLog: any;
	isError: boolean;
	newFormData: any;
	newFormId: any;
	oldFormData: any;
	oldFormId: any;
	stoppedWorking: any;
	toState: any;
	userId: number;
	userMail: string;
	userName: string;
}

export class ChangeFormTaxResponse {
	accessories: number;
	description: string;
	expirationDate: number;
	formAccess: number;
	formId: number;
	formNumber: number;
	hasErrors: boolean;
	taxesToPay: number;
}

export class TopProviderResponse {
	documentsCount: number;
	documentsTotal: number;
	id: number;
	vendorNIT: string;
	vendorName: string;
}

export class SearchTopProvider {
	company: number;
	month: number;
	year: number;

	constructor(company: number, month: number, year: number) {
		this.company = company;
		this.month = month;
		this.year = year;
	}
}